<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Devices" title="View Devices" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
		
							<div class="col-md-12">
								<div class="row">

                                    <div class="row mb-3">
                                        <div class="col-10">
                                            <h4><i class="icofont icofont-company"></i>&nbsp;Devices</h4>
                                        </div>

										<div class="col-md-2 float-end">
											<div class="btn btn-info float-end" @click="openModal">Upload</div>
										</div>
                                    </div>

								</div>

							</div>
						</div>
					</div>

					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list filter-sort">
								<div class="row mb-2 align-items-center">

									<div class="col-md-2 text-start">
									<!--<button class="btn btn-light me-2">Print</button>-->
										<button class="btn btn-light" @click="exportToExcel">Excel</button>
									</div>

									<div class="col-md-8"></div>

									<div class="col-md-2 text-end">
										<input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchDevices()" />
									</div>

								</div>
							</div>

		
							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
											<th>Sl.No</th>
											<th>IMEI & ICCID</th>
											<th>UIN</th>
											<th>Primary & Secondary No.</th>
											<th>Vehicle</th>
											<th>Action</th>
										</tr>
									</thead>

									<tbody v-if="Boolean(devices.length)">
										<tr align="center" v-for="(device,index) in devices" :key="device.id">
                                            <td>{{index + 1}}</td>
											<td>{{device.imei}} <br> {{device.iccid}} <br> {{device.sim_provider}}</td>
                                            <td>{{device.uin}}</td>
                                            <td>{{device.primary_mobile_number}} <br> {{device.secondary_mobile_number}}</td>
                                            <td>{{device.vehicle_number}}</td>
                                            <td>
												<router-link :to="{ name: 'device_details_page', query: { imei: device.imei } }" class="btn btn-primary btn-sm mb-2">Details</router-link>
												<router-link :to="{ name: 'update_vehicle_data',params:{imei:device.imei} }" class="btn btn-warning btn-sm mb-2 ms-1" v-if="!device.vehicle_number">Add Vehicle</router-link><br>
												<button class="btn btn-success btn-sm mb-2 ms-1" v-if="Number(device.tag_status) === 2" @click="openTagModal(device)">Tag</button>
												<button class="btn btn-info btn-sm mb-2 ms-1" v-if="Number(device.tag_status) === 1" @click="openUpdateTagModal(device)">Update Tag</button>
												<button class="btn btn-danger btn-sm mb-2 ms-1" v-if="Number(device.tag_status) === 1" @click="confirmUntag(device)">Untag</button>
												<button
													class="btn btn-dark btn-sm mb-2 ms-1"
													v-if="device.iccid && String(device.iccid).trim()"
													@click="confirmRemoveSim(device)"
												>Remove SIM</button>
												<button
													class="btn btn-success btn-sm mb-2 ms-1"
													v-if="!device.iccid || !String(device.iccid).trim()"
													@click="openAllocateSimModal(device)"
												>Allocate SIM</button>
												<router-link :to="{ name: 'device_extension', params: { device_id: device.tc_device_id } }" class="btn btn-secondary btn-sm ms-2 mb-2">Extension</router-link>
												<a class="btn btn-info btn-sm ms-1 mb-2" @click="openSimDataModal(device)" v-if="canShowSimData(device)">Show SIM Data</a>
												<button
													class="btn btn-warning btn-sm ms-1 mb-2"
													v-if="canUpdateExpiration"
													@click="openExpirationModal(device)"
												>Update Expiration</button>
                                            </td>
                                        </tr>	
									</tbody>

									 <tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available in the table</td>
										</tr>

									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(devices.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchDevices(page.url + '&keyword=' + keyword  +  '&limit=' + listing_length)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav> 
							<!----pagination ends --->
		
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title="modal_title">
			<template #body>
				<form v-if="modal_mode === 'upload'" @submit.prevent="uploadFile" enctype="multipart/form-data">
					<div class="row mt-3">
						<div class="col-md-12">
							<div class="form-group">
								<input 
									class="form-control" 
									type="file" 
									accept=".xls, .xlsx" 
									@change="handleFileUpload" 
									ref="file"
									:class="{'is-invalid': uploadError}" 
								/>
								<small class="text-muted d-block">Accepted formats: .xls, .xlsx (Max size: 5MB)</small>
								
								<div v-if="uploadError" class="invalid-feedback d-block">
									{{ uploadError }}
								</div>
							</div>
						</div>
					</div>
					
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" :disabled="!selectedFile || isUploading">
							<span v-if="isUploading">
								<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
								Uploading...
							</span>
							<span v-else>{{ button_title }}</span>
						</button>
						<button class="btn btn-light" @click="closeModal()" :disabled="isUploading">
							Cancel
						</button>
					</div>
				</form>

				<form
					v-else-if="modal_mode === 'tag'"
					:key="'tag-device-form-' + tag_modal_key"
					@submit.prevent="submitTagDevice"
					enctype="multipart/form-data"
				>
					<div class="row mt-2">
						<div class="col-md-12 mb-2">
							<label class="form-label">IMEI</label>
							<input type="text" class="form-control" v-model="tagForm.imei" disabled />
						</div>

						<div class="col-md-12 mb-2">
							<label class="form-label">Tag Date</label>
							<input type="date" class="form-control" v-model="tagForm.tag_date" />
						</div>

						<div class="col-md-12 mb-2">
							<label class="form-label">Surakshamitra ID</label>
							<input
								type="text"
								class="form-control"
								v-model="tagForm.surakshamitra_id"
								:class="{ 'is-invalid': tagErrors.surakshamitra_id }"
								placeholder="Enter surakshamitra id"
							/>
							<div v-if="tagErrors.surakshamitra_id" class="invalid-feedback d-block">{{ tagErrors.surakshamitra_id }}</div>
						</div>

						<div class="col-md-12 mb-2">
							<label class="form-label">Installation Certificate<span class="text-danger">*</span></label>
							<input
								type="file"
								class="form-control"
								ref="installationCertificateFile"
								@change="handleTagFileUpload($event, 'installation_certificate')"
								:class="{ 'is-invalid': tagErrors.installation_certificate }"
							/>
							<div v-if="tagErrors.installation_certificate" class="invalid-feedback d-block">{{ tagErrors.installation_certificate }}</div>
						</div>

						<div class="col-md-12 mb-2">
							<label class="form-label">Approval Certificate</label>
							<input
								type="file"
								class="form-control"
								ref="approvalCertificateFile"
								@change="handleTagFileUpload($event, 'approval_certificate')"
								:class="{ 'is-invalid': tagErrors.approval_certificate }"
							/>
							<div v-if="tagErrors.approval_certificate" class="invalid-feedback d-block">{{ tagErrors.approval_certificate }}</div>
						</div>
					</div>

					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" :disabled="isSubmittingTag">
							<span v-if="isSubmittingTag">
								<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
								Processing...
							</span>
							<span v-else>{{ button_title }}</span>
						</button>
						<button class="btn btn-light" @click="closeModal()" :disabled="isSubmittingTag">
							Cancel
						</button>
					</div>
				</form>

				<form
					v-else-if="modal_mode === 'allocate'"
					:key="'allocate-sim-form-' + allocate_modal_key"
					@submit.prevent="submitAssignSim"
				>
					<div class="row mt-2">
						<div class="col-md-12 mb-2">
							<label class="form-label">IMEI</label>
							<input type="text" class="form-control" v-model="allocateForm.imei" disabled />
						</div>

						<div class="col-md-12 mb-2">
							<label class="form-label">Select SIM<span class="text-danger">*</span></label>
							<div class="position-relative">
								<input
									v-model="sim_search"
									class="form-control"
									placeholder="Search ICCID..."
									@input="searchAvailableSim"
									@focus="onSimSearchFocus"
									@blur="hideSimSuggestions"
									:class="{ 'is-invalid': allocateErrors.sim_id }"
								/>
								<div
									v-if="showSimSuggestions && filteredSimList.length > 0"
									class="position-absolute w-100 bg-white border rounded shadow-sm"
									style="z-index: 1000; max-height: 200px; overflow-y: auto;"
								>
									<div
										v-for="sim in filteredSimList"
										:key="sim.id"
										class="p-2 border-bottom"
										@mousedown.prevent="selectAvailableSim(sim)"
										style="cursor: pointer;"
									>
										<div class="fw-bold">{{ sim.iccid }}</div>
										<small class="text-muted">
											{{ sim.msisdn_1 || '-' }} / {{ sim.msisdn_2 || '-' }}
											<span v-if="sim.sim"> · {{ sim.sim }}</span>
										</small>
									</div>
								</div>
							</div>
							<div v-if="selectedSim" class="mt-2">
								<small class="text-success">
									<i class="icofont icofont-check-circled me-1"></i>
									Selected: <strong>{{ selectedSim.iccid }}</strong>
								</small>
							</div>
							<div v-if="allocateErrors.sim_id" class="invalid-feedback d-block">{{ allocateErrors.sim_id }}</div>
						</div>

						<div class="col-md-6 mb-2" v-if="selectedSim">
							<label class="form-label">SIM 1</label>
							<input type="text" class="form-control" :value="selectedSim.msisdn_1 || '-'" disabled />
						</div>
						<div class="col-md-6 mb-2" v-if="selectedSim">
							<label class="form-label">SIM 2</label>
							<input type="text" class="form-control" :value="selectedSim.msisdn_2 || '-'" disabled />
						</div>
						<div class="col-md-12 mb-2" v-if="selectedSim">
							<label class="form-label">Provider</label>
							<input type="text" class="form-control" :value="selectedSim.sim || '-'" disabled />
						</div>
					</div>

					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" :disabled="isSubmittingAllocate">
							<span v-if="isSubmittingAllocate">
								<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
								Processing...
							</span>
							<span v-else>{{ button_title }}</span>
						</button>
						<button class="btn btn-light" type="button" @click="closeModal()" :disabled="isSubmittingAllocate">
							Cancel
						</button>
					</div>
				</form>

				<form
					v-else-if="modal_mode === 'expiry'"
					:key="'expiry-device-form-' + expiry_modal_key"
					@submit.prevent="submitExpirationUpdate"
				>
					<div class="row mt-2">
						<div class="col-md-12 mb-2">
							<label class="form-label">IMEI</label>
							<input type="text" class="form-control" v-model="expiryForm.imei" disabled />
						</div>

						<div class="col-md-12 mb-2">
							<label class="form-label">Expiration date<span class="text-danger">*</span></label>
							<input
								type="date"
								class="form-control"
								v-model="expiryForm.expirationtime"
								:class="{ 'is-invalid': expiryErrors.expirationtime }"
							/>
							<div v-if="expiryErrors.expirationtime" class="invalid-feedback d-block">{{ expiryErrors.expirationtime }}</div>
						</div>
					</div>

					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" :disabled="isSubmittingExpiry">
							<span v-if="isSubmittingExpiry">
								<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
								Updating...
							</span>
							<span v-else>Update</span>
						</button>
						<button class="btn btn-light" type="button" @click="closeModal()" :disabled="isSubmittingExpiry">
							Cancel
						</button>
					</div>
				</form>
			</template>
		</DynamicModal>

		<!-- Vodafone SIM data -->
		<div class="modal fade" id="simDataModalViewDevices" tabindex="-1" aria-labelledby="simDataModalViewDevicesLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="simDataModalViewDevicesLabel">Vodafone SIM Data</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div v-if="simDataModal.loading" class="text-center py-4">
							<div class="spinner-border text-primary" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
						</div>
						<div v-else-if="simDataModal.error" class="alert alert-danger mb-0">{{ simDataModal.error }}</div>
						<div v-else-if="simDataModal.details" class="table-responsive">
							<table class="table table-bordered mb-0">
								<tbody>
									<tr>
										<th style="width: 35%">ICCID</th>
										<td>{{ simDataModal.details.iccid || "—" }}</td>
									</tr>
									<tr>
										<th>Primary TSP Name</th>
										<td>{{ simDataModal.details.Primary_TSP_Name || "—" }}</td>
									</tr>
									<tr>
										<th>Fallback TSP Name</th>
										<td>{{ simDataModal.details.Fallback_TSP_Name || "—" }}</td>
									</tr>
									<tr>
										<th>Primary TSP MSISDN</th>
										<td>{{ simDataModal.details.Primary_TSP_MSISDN || "—" }}</td>
									</tr>
									<tr>
										<th>Fallback TSP MSISDN</th>
										<td>{{ simDataModal.details.Fallback_TSP_MSISDN || "—" }}</td>
									</tr>
									<tr>
										<th>Primary TSP Validity</th>
										<td>{{ simDataModal.details.Primary_TSP_Validity ? $filters.formatDate(simDataModal.details.Primary_TSP_Validity) : "—" }}</td>
									</tr>
									<tr>
										<th>Fallback TSP Validity</th>
										<td>{{ simDataModal.details.Fallback_TSP_Validity ? $filters.formatDate(simDataModal.details.Fallback_TSP_Validity) : "—" }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
					</div>
				</div>
			</div>
		</div>

   </div>
</template>


<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Coupons eport",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},
		
		data() {

			const now = new Date()
			const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
			const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
			const minDate = new Date('2021-01-01') 
	      
			return {
				devices: [],
				pagination: {},
				start_date: '2021-01-01',
				end_date: today_str,
				
				min: minDate,
				max: today,
				keyword: "",
				listing_length: 10,
				token: "",
				i: 1,				

				modal_title: "Upload Excel",
				button_title: "Upload",
				modal_mode: "upload",
				
				// File upload related properties
				selectedFile: null,
				isUploading: false,
				uploadError: null,

				isSubmittingTag: false,
				tag_action: "create",
				tag_modal_key: 0,
				tagForm: {
					imei: "",
					tag_date: today_str,
					surakshamitra_id: "",
					installation_certificate: null,
					approval_certificate: null,
				},
				tagErrors: {},

				isSubmittingAllocate: false,
				allocate_modal_key: 0,
				allocateDeviceId: null,
				availableSims: [],
				sim_search: "",
				selectedSim: null,
				showSimSuggestions: false,
				filteredSimList: [],
				allocateForm: {
					imei: "",
				},
				allocateErrors: {},

				simDataModalInstance: null,
				simDataModal: {
					iccid: "",
					loading: false,
					error: "",
					details: null,
				},

				role_id: null,
				isSubmittingExpiry: false,
				expiry_modal_key: 0,
				expiryForm: {
					imei: "",
					expirationtime: "",
				},
				expiryErrors: {},
			};
		},
		computed: {
			canUpdateExpiration() {
				return Number(this.role_id) === 13;
			},
		},
		mounted() {
			const simDataEl = document.getElementById("simDataModalViewDevices");
			if (simDataEl) this.simDataModalInstance = new Modal(simDataEl);
		},

		created() {
			this.fetchSettings();
			this.fetchDevices();
		},

		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			fetchSettings() {
				this.getToken();
				this.$axios
					.get("/staffs/settings", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						const responseData = res.data?.data || res.data;
						this.role_id = responseData?.admin?.role_id ?? null;
					})
					.catch(() => {
						this.role_id = null;
					});
			},

			toDateInputValue(value) {
				if (!value) return "";
				const raw = String(value).trim();
				if (!raw) return "";
				if (/^\d{4}-\d{2}-\d{2}/.test(raw)) {
					return raw.slice(0, 10);
				}
				const d = new Date(raw);
				if (isNaN(d.getTime())) return "";
				return d.toISOString().slice(0, 10);
			},

			openExpirationModal(device) {
				this.expiry_modal_key += 1;
				this.expiryForm = {
					imei: device?.imei || "",
					expirationtime: this.toDateInputValue(device?.expirationtime),
				};
				this.expiryErrors = {};
				this.isSubmittingExpiry = false;
				this.modal_title = "Update Expiration Time";
				this.button_title = "Update";
				this.modal_mode = "expiry";
				this.showModal();
			},

			async submitExpirationUpdate() {
				this.expiryErrors = {};
				if (!String(this.expiryForm.expirationtime || "").trim()) {
					this.expiryErrors.expirationtime = "Select expiration date";
					return;
				}
				this.isSubmittingExpiry = true;
				try {
					this.getToken();
					const response = await this.$axios.post(
						"/staffs/updateDeviceExpirationTime",
						{
							imei: this.expiryForm.imei,
							expirationtime: this.expiryForm.expirationtime,
						},
						{ headers: { Authorization: "Bearer " + this.token } }
					);
					if (response.data?.status === true || response.data?.status === "true") {
						this.$swal("", response.data?.message || "Expiration time updated successfully", "success");
						this.closeModal();
						this.fetchDevices(this.active_page_url);
					} else {
						const message = this.getApiErrorMessage(response.data, "Failed to update expiration time");
						this.$swal("", message, "error");
					}
				} catch (error) {
					const message = this.getApiErrorMessage(error?.response?.data, "Something went wrong");
					this.$swal("", message, "error");
				} finally {
					this.isSubmittingExpiry = false;
				}
			},

			isVodafoneSimProvider(device) {
				const raw = String(device?.sim_provider || "").trim().toLowerCase();
				if (!raw) return false;
				const normalized = raw.replace(/\s*\+\s*/g, " ").replace(/\s+/g, " ").trim();
				if (normalized === "vodafone") return true;
				return normalized.includes("vodafone") && normalized.includes("idea");
			},

			canShowSimData(device) {
				return this.isVodafoneSimProvider(device) && String(device?.iccid || "").trim() !== "";
			},

			openSimDataModal(device) {
				const iccid = String(device?.iccid || "").trim();
				if (!iccid) {
					this.$swal("", "ICCID not available for this device", "error");
					return;
				}
				this.getToken();
				this.simDataModal.iccid = iccid;
				this.simDataModal.loading = true;
				this.simDataModal.error = "";
				this.simDataModal.details = null;
				if (this.simDataModalInstance) this.simDataModalInstance.show();
				this.$axios
					.get("/staffs/iccidDetails", {
						params: { iccid },
						headers: { Authorization: "Bearer " + this.token },
					})
					.then((res) => {
						const ok = res.data?.status === true || res.data?.status === "true";
						if (ok && res.data?.data) {
							this.simDataModal.details = res.data.data;
						} else {
							this.simDataModal.error = res.data?.message || "Failed to fetch SIM data";
						}
					})
					.catch((err) => {
						this.simDataModal.error = err?.response?.data?.message || "Something went wrong";
					})
					.finally(() => {
						this.simDataModal.loading = false;
					});
			},

			fetchDevices(page_url = null) {
				this.getToken();
				let url = "/staffs/devices?limit=" + this.listing_length  +  "&keyword=" + this.keyword;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.devices = responseData.devices.data;
						this.pagination = responseData.devices.links;
						this.from = responseData.devices.from;
						this.to = responseData.devices.to;
						this.total = responseData.devices.total;
						
					})
					.catch((err) => console.log(err));
			},

			handleFileUpload(event) {
				const file = event.target.files[0];
				if (file) {
					// Check file type
					if (!file.name.match(/\.(xls|xlsx)$/)) {
						this.uploadError = 'Please select an Excel file (.xls or .xlsx)';
						this.selectedFile = null;
						return;
					}
					
					// Check file size (e.g., max 5MB)
					if (file.size > 5 * 1024 * 1024) {
						this.uploadError = 'File size should not exceed 5MB';
						this.selectedFile = null;
						return;
					}

					this.selectedFile = file;
					this.uploadError = null;
				}
			},


			async uploadFile() {
				// Clear any previous errors
				this.uploadError = null;

				// Validate file selection
				if (!this.selectedFile) {
					this.uploadError = 'Please select a file first';
					return;
				}

				this.isUploading = true;

				try {
					// Get token first
					this.getToken();
					if (!this.token) {
						throw new Error('Authentication token not found');
					}

					const formData = new FormData();
					formData.append('file', this.selectedFile);

					const response = await this.$axios.post('/staffs/importDeviceData', formData, {
						headers: {
							'Content-Type': 'multipart/form-data',
							'Authorization': 'Bearer ' + this.token
						}
					});

					if (response.data.status) {
						// Success case
						await this.$swal({
							title: 'Success',
							text: response.data.message,
							icon: 'success',
							timer: 2000,
							showConfirmButton: false
						});
						
						this.closeModal();
						await this.fetchDevices(); // Refresh the list
					} else {
						// API returned error
						throw new Error(response.data.message || 'Failed to upload file');
					}
				} catch (error) {
					console.error('Upload error:', error);
					
					// Handle different types of errors
					let errorMessage = 'Error uploading file. Please try again.';
					
					if (error.response) {
						// Server responded with error
						errorMessage = error.response.data?.message || errorMessage;
					} else if (error.message) {
						// Custom error message
						errorMessage = error.message;
					}

					this.uploadError = errorMessage;
					await this.$swal({
						title: 'Error',
						text: errorMessage,
						icon: 'error'
					});
				} finally {
					this.isUploading = false;
					this.selectedFile = null;
					if (this.$refs.file) {
						this.$refs.file.value = ''; // Reset file input
					}
				}
			},


			openModal() {
				this.modal_mode = "upload";
				this.modal_title = "Upload Excel";
				this.button_title = "Upload";
				this.showModal();
			},

			openAllocateSimModal(device) {
				this.allocate_modal_key += 1;
				this.modal_mode = "allocate";
				this.modal_title = "Allocate SIM";
				this.button_title = "Allocate";
				this.allocateDeviceId = device.id;
				this.resetAllocateForm(device);
				this.fetchAvailableSimList();
				this.showModal();
			},

			resetAllocateForm(device) {
				this.allocateForm = {
					imei: device?.imei || "",
				};
				this.sim_search = "";
				this.selectedSim = null;
				this.showSimSuggestions = false;
				this.filteredSimList = [];
				this.allocateErrors = {};
			},

			fetchAvailableSimList() {
				this.getToken();
				return this.$axios
					.get("/staffs/getAvailableSimList", {
						headers: { Authorization: "Bearer " + this.token },
					})
					.then((res) => {
						const sims = res.data?.data?.sims;
						this.availableSims = Array.isArray(sims) ? sims : [];
						return this.availableSims;
					})
					.catch((err) => {
						console.error("Error fetching available SIM list:", err);
						this.availableSims = [];
						return [];
					});
			},

			onSimSearchFocus() {
				this.showSimSuggestions = true;
				if (!this.availableSims.length) {
					this.fetchAvailableSimList();
				}
			},

			searchAvailableSim() {
				if (this.selectedSim && String(this.sim_search).trim() !== String(this.selectedSim.iccid)) {
					this.selectedSim = null;
				}

				const q = this.sim_search.trim().toLowerCase();
				if (!q) {
					this.filteredSimList = [];
					this.showSimSuggestions = false;
					return;
				}

				this.filteredSimList = this.availableSims.filter((sim) => {
					const iccid = (sim.iccid || "").toLowerCase();
					const msisdn1 = (sim.msisdn_1 || "").toLowerCase();
					const msisdn2 = (sim.msisdn_2 || "").toLowerCase();
					const provider = (sim.sim || "").toLowerCase();
					return iccid.includes(q) || msisdn1.includes(q) || msisdn2.includes(q) || provider.includes(q);
				});

				this.showSimSuggestions = this.filteredSimList.length > 0;
			},

			selectAvailableSim(sim) {
				this.selectedSim = sim;
				this.sim_search = sim.iccid || "";
				this.showSimSuggestions = false;
				this.filteredSimList = [];
				this.allocateErrors.sim_id = "";
			},

			hideSimSuggestions() {
				setTimeout(() => {
					this.showSimSuggestions = false;
				}, 200);
			},

			async submitAssignSim() {
				this.allocateErrors = {};
				if (!this.selectedSim || !this.selectedSim.id) {
					this.allocateErrors.sim_id = "Please select a SIM";
					return;
				}
				if (!this.allocateDeviceId) {
					this.$swal("", "Device not found", "error");
					return;
				}

				this.isSubmittingAllocate = true;
				try {
					this.getToken();
					const response = await this.$axios.post("/staffs/assignSim", null, {
						headers: { Authorization: "Bearer " + this.token },
						params: {
							device_id: this.allocateDeviceId,
							sim_id: this.selectedSim.id,
						},
					});

					if (response.data.status) {
						this.$swal("", response.data.message || "SIM allocated successfully", "success");
						this.closeModal();
						this.fetchDevices(this.active_page_url);
					} else {
						const message = this.getApiErrorMessage(response.data, "Failed to allocate SIM");
						this.$swal("", message, "error");
					}
				} catch (error) {
					const message = this.getApiErrorMessage(error?.response?.data, "Something went wrong");
					this.$swal("", message, "error");
				} finally {
					this.isSubmittingAllocate = false;
				}
			},

			openTagModal(device) {
				this.tag_modal_key += 1;
				this.tag_action = "create";
				this.modal_mode = "tag";
				this.modal_title = "Tag Device";
				this.button_title = "Tag";
				this.resetTagForm(device, false);
				this.showModal();
			},

			openUpdateTagModal(device) {
				this.tag_modal_key += 1;
				this.tag_action = "update";
				this.modal_mode = "tag";
				this.modal_title = "Update Tag";
				this.button_title = "Update";
				this.resetTagForm(device, true);
				this.showModal();
			},

			normalizeTagDateForInput(val) {
				if (val == null || val === "") {
					return new Date().toISOString().split("T")[0];
				}
				const s = String(val).trim();
				const iso = s.match(/^(\d{4}-\d{2}-\d{2})/);
				if (iso) {
					return iso[1];
				}
				const dmy = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
				if (dmy) {
					const day = dmy[1].padStart(2, "0");
					const month = dmy[2].padStart(2, "0");
					return `${dmy[3]}-${month}-${day}`;
				}
				const t = Date.parse(s);
				if (!Number.isNaN(t)) {
					return new Date(t).toISOString().split("T")[0];
				}
				return new Date().toISOString().split("T")[0];
			},

			resetTagForm(device, forUpdate = false) {
				const today = new Date().toISOString().split("T")[0];
				const hasDevice = device && Object.keys(device).length;
				let tag_date = today;
				let surakshamitra_id = "";
				if (forUpdate && hasDevice) {
					tag_date = this.normalizeTagDateForInput(
						device.tag_date ?? device.tagDate ?? device.tagged_date
					);
					surakshamitra_id = String(
						device.surakshamitra_id ?? device.surakshamitraId ?? ""
					).trim();
				}
				this.tagForm = {
					imei: device?.imei || "",
					tag_date,
					surakshamitra_id,
					installation_certificate: null,
					approval_certificate: null,
				};
				this.tagErrors = {};
				this.clearTagFileInputs();
			},

			clearTagFileInputs() {
				if (this.$refs.installationCertificateFile) {
					this.$refs.installationCertificateFile.value = "";
				}
				if (this.$refs.approvalCertificateFile) {
					this.$refs.approvalCertificateFile.value = "";
				}
			},

			handleTagFileUpload(event, key) {
				const file = event?.target?.files?.[0] || null;
				this.tagForm[key] = file;
				if (file) {
					this.tagErrors[key] = "";
				}
			},

			appendMultipartNullableScalar(formData, key, value) {
				const empty =
					value === null ||
					value === undefined ||
					(typeof value === "string" && value.trim() === "");
				formData.append(key, empty ? "" : String(value));
			},

			appendTagCertificateField(formData, key, file, isUpdate) {
				if (file instanceof File) {
					formData.append(key, file);
					return;
				}
				if (isUpdate) {
					return;
				}
			},

			getApiErrorMessage(payload, fallback = "Something went wrong") {
				if (!payload) return fallback;
				if (typeof payload === "string") return payload;

				if (payload.message && typeof payload.message === "string") {
					return payload.message;
				}

				if (
					payload.message &&
					typeof payload.message === "object" &&
					!Array.isArray(payload.message)
				) {
					const msgs = [];
					Object.values(payload.message).forEach((v) => {
						if (Array.isArray(v)) {
							v.forEach((m) => {
								if (typeof m === "string") {
									msgs.push(m);
								}
							});
						} else if (typeof v === "string") {
							msgs.push(v);
						}
					});
					if (msgs.length) {
						return msgs.join("\n");
					}
				}

				const data = payload.data;
				if (data && typeof data === "object") {
					const validationMessages = [];
					Object.keys(data).forEach((key) => {
						const value = data[key];
						if (Array.isArray(value)) {
							value.forEach((msg) => {
								if (typeof msg === "string") validationMessages.push(msg);
							});
						}
					});
					if (validationMessages.length) {
						return validationMessages.join("\n");
					}
					if (data.message && typeof data.message === "string") {
						return data.message;
					}
				}

				return fallback;
			},

			async submitTagDevice() {
				this.tagErrors = {};
				const isUpdate = this.tag_action === "update";
				if (!this.tagForm.surakshamitra_id) {
					this.tagErrors.surakshamitra_id = "Surakshamitra ID is required";
				}
				if (!isUpdate) {
					if (!this.tagForm.installation_certificate) {
						this.tagErrors.installation_certificate = "Installation certificate is required";
					}
				}

				if (Object.keys(this.tagErrors).length) {
					return;
				}

				this.isSubmittingTag = true;
				try {
					this.getToken();
					const formData = new FormData();
					this.appendMultipartNullableScalar(formData, "imei", this.tagForm.imei);
					this.appendMultipartNullableScalar(formData, "tag_date", this.tagForm.tag_date);
					this.appendMultipartNullableScalar(
						formData,
						"surakshamitra_id",
						this.tagForm.surakshamitra_id
					);
					this.appendTagCertificateField(
						formData,
						"installation_certificate",
						this.tagForm.installation_certificate,
						isUpdate
					);
					this.appendTagCertificateField(
						formData,
						"approval_certificate",
						this.tagForm.approval_certificate,
						isUpdate
					);

					const url = isUpdate ? "/staffs/updateTag" : "/staffs/tagDevice";
					const response = await this.$axios.post(url, formData, {
						headers: {
							Authorization: "Bearer " + this.token,
							"Content-Type": "multipart/form-data",
						},
					});

					if (response.data.status) {
						this.$swal(
							"",
							response.data.message ||
								(isUpdate ? "Tag updated successfully" : "Device tagged successfully"),
							"success"
						);
						this.closeModal();
						this.fetchDevices(this.active_page_url);
					} else {
						const message = this.getApiErrorMessage(
							response.data,
							isUpdate ? "Failed to update tag" : "Failed to tag device"
						);
						this.$swal("", message, "error");
					}
				} catch (error) {
					const message = this.getApiErrorMessage(error?.response?.data, "Something went wrong");
					this.$swal("", message, "error");
				} finally {
					this.isSubmittingTag = false;
				}
			},

			async confirmUntag(device) {
				this.$swal({
					icon: "warning",
					title: "Confirm",
					text: "Are you sure you want to untag this device?",
					showCancelButton: true,
					confirmButtonText: "Yes",
					confirmButtonColor: "#ef5350",
					cancelButtonText: "No",
					position: "center",
					showConfirmButton: true,
					timer: "",
					toast: false,
					cancelButtonColor: "#e0e0e0",
				}).then((result) => {
					if (result.value) {
						this.untagDevice(device.imei);
					}
				});
			},

			async untagDevice(imei) {
				try {
					this.getToken();
					const response = await this.$axios.get("/staffs/untagDevice", {
						headers: { Authorization: "Bearer " + this.token },
						params: { imei },
					});

					if (response.data.status) {
						this.$swal("", response.data.message || "Device untagged successfully", "success");
						this.fetchDevices(this.active_page_url);
					} else {
						const message = this.getApiErrorMessage(response.data, "Failed to untag device");
						this.$swal("", message, "error");
					}
				} catch (error) {
					const message = this.getApiErrorMessage(error?.response?.data, "Something went wrong");
					this.$swal("", message, "error");
				}
			},

			confirmRemoveSim(device) {
				this.$swal({
					icon: "warning",
					title: "Confirm",
					text: "Are you sure you want to remove SIM from this device?",
					showCancelButton: true,
					confirmButtonText: "Yes",
					confirmButtonColor: "#ef5350",
					cancelButtonText: "No",
					position: "center",
					showConfirmButton: true,
					timer: "",
					toast: false,
					cancelButtonColor: "#e0e0e0",
				}).then((result) => {
					if (result.value) {
						this.removeSim(device.id);
					}
				});
			},

			async removeSim(deviceId) {
				try {
					this.getToken();
					const response = await this.$axios.post("/staffs/removeSim", null, {
						headers: { Authorization: "Bearer " + this.token },
						params: { device_id: deviceId },
					});

					if (response.data.status) {
						this.$swal("", response.data.message || "SIM removed successfully", "success");
						this.fetchDevices(this.active_page_url);
					} else {
						const message = this.getApiErrorMessage(response.data, "Failed to remove SIM");
						this.$swal("", message, "error");
					}
				} catch (error) {
					const message = this.getApiErrorMessage(error?.response?.data, "Something went wrong");
					this.$swal("", message, "error");
				}
			},

			closeModal() {
				if (this.modal_mode === "tag") {
					this.resetTagForm({}, false);
					this.tag_action = "create";
				}
				if (this.modal_mode === "allocate") {
					this.resetAllocateForm({});
					this.allocateDeviceId = null;
				}
				if (this.modal_mode === "expiry") {
					this.expiryForm = { imei: "", expirationtime: "" };
					this.expiryErrors = {};
					this.isSubmittingExpiry = false;
				}
				this.hideModal();
			},
            
			clearForm() {
				this.edit = false;
				this.modal_title = "Upload Excel";
				this.button_title = "Upload";
				this.errors = {};
			},

			async exportToExcel() {
				try {
					this.getToken();

					// Call the export API
					const response = await this.$axios.get('/staffs/deviceExcelReport', {
						headers: { 
							Authorization: "Bearer " + this.token 
						},
						responseType: 'blob' // Important for file downloads
					});

					// Create download link
					const blob = new Blob([response.data], { 
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
					});
					const url = window.URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.href = url;
					link.download = `devices_export_${new Date().toISOString().split('T')[0]}.xlsx`;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					window.URL.revokeObjectURL(url);

				} catch (error) {
					console.error('Export error:', error);
				}
			},

		},
	};
</script>
